import {
    Component,
    Input,
    SimpleChanges,
    OnChanges,
    inject,
} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../../common/grid-page.component';
import {
    EmptyCheckInHistoryGridViewDto,
    EmptyCheckInStatus,
    ShuntLocationType,
    ShuntPriority,
} from '@services';
import EnumUtils from '../../../../../shared/enum-utils';
import { CapitalCasePipe } from '../../../../../pipes/capital-case.pipe';
import { CommonModule } from '@angular/common';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';
import { ShuntPriorityPipe } from 'src/app/pipes/shunt-priority.pipe';
import { EmptyCheckInStatusPipe } from 'src/app/pipes/empty-check-in-status.pipe';

@Component({
    selector: 'app-empty-check-in-history',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        CapitalCasePipe,
        FilterPanelComponent,
        DxFormComponent,
        UserAvatarEmailComponent,
        ShuntPriorityPipe,
        EmptyCheckInStatusPipe,
    ],
    providers: [EmptyCheckInStatusPipe, ShuntPriorityPipe],
    templateUrl: './empty-check-in-history.component.html',
})
export class EmptyCheckInHistoryComponent
    extends GridPageComponent<EmptyCheckInHistoryGridViewDto>
    implements OnChanges
{
    @Input() number: string | null = null;
    private emptyCheckInStatusPipe = inject(EmptyCheckInStatusPipe);
    private shuntPriorityPipe = inject(ShuntPriorityPipe);
    protected override exportName: string = 'Empty Check-In Report';
    protected offset: number = 160;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.emptyCheckInHistory();

    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType);

    shuntPriorityOptions = EnumUtils.getEnumOptions(ShuntPriority, (v) =>
        this.shuntPriorityPipe.transform(v),
    );

    statusOptions = EnumUtils.getEnumOptions(EmptyCheckInStatus, (v) =>
        this.emptyCheckInStatusPipe.transform(v),
    );

    protected override filterConfig: FilterConfig[] = [
        {
            field: 'employee.name',
            op: 'contains',
            customFilter: this.nameOrEmailFilter,
        },
        { field: 'created', op: '>=' },
        { field: 'status', op: '=' },
        { field: 'location', op: '=' },
        { field: 'number', op: 'contains' },
        { field: 'shuntPriority', op: '=' },
        { field: 'notes', op: 'contains' },
    ];

    constructor() {
        super();
        this.init(EmptyCheckInHistoryGridViewDto);
    }

    protected getBadgeClass(status: EmptyCheckInStatus): string {
        return EnumUtils.getEmptyCheckInStatusBadgeClass(status);
    }

    protected getShuntPriorityBadgeClass(status: ShuntPriority): string {
        return EnumUtils.getShuntPriorityBadgeClass(status);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['number']) {
            this.dataSource = this.dataSources.emptyCheckInHistory(this.number);
        }
    }
}
